import * as RadixDropdown from '@radix-ui/react-dropdown-menu'
import { styled } from '../../../config'

const Content = styled(RadixDropdown.Content, {
  zIndex: 100,
  color: '$black',
  background: '$gray0100',
  boxSizing: 'border-box',
  padding: '8px',
  borderWidth: '1px',
  borderColor: '$gray0400',
  borderStyle: 'solid',
  borderRadius: '$8',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  variants: {
    mobile: {
      true: {
        overflow: 'scroll',
        width: 'calc(100vw - 32px)',
        maxHeight: '60vh',
        flexWrap: 'nowrap'
      },
      false: {
        overflow: 'auto',
        flexWrap: 'wrap'
      }
    },
    dark: {
      true: {
        color: '$white',
        backgroundColor: '$gray0800',
        borderColor: '$gray0700'
      }
    }
  }
})

const Trigger = styled(RadixDropdown.Trigger, {
  cursor: 'pointer'
})

const Item = styled(RadixDropdown.Item, {
  padding: '6px 12px',
  fontSize: '$14',
  cursor: 'pointer',
  outline: 'none',
  borderRadius: '$8',
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  lineHeight: '20px',
  '&:hover': {
    color: '$gray0900',
    background: 'rgba(0,0,0,.03)'
  },

  variants: {
    dark: {
      true: {
        color: '$whiteA600',
        '&:hover': {
          color: '$gray0200',
          backgroundColor: '$whiteA050'
        },
        '&[aria-disabled="true"]': {
          '&:hover': {
            color: '$whiteA600 !important',
            backgroundColor: 'transparent !important',
            cursor: 'not-allowed'
          }
        }
      }
    }
  }
})

const Label = styled(RadixDropdown.Label, {
  fontSize: '$12',
  fontWeight: '$medium',
  margin: '8px 0',
  variants: {
    dark: {
      true: {
        color: '$whiteA600'
      }
    }
  }
})

const Separator = styled(RadixDropdown.Separator, {
  height: '1px',
  margin: '8px 0',
  variants: {
    dark: {
      true: {
        backgroundColor: '$whiteA100'
      }
    }
  }
})

export const DropdownPrimitives = {
  Content,
  Trigger,
  Item,
  Label,
  Separator
}
